import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { GrupoProdutoService } from './../../../service/produto/grupo-produto.service';
import { GrupoProdutoModel } from './../../../model/produto/grupo-produto.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-grupo-produto',
  templateUrl: './grupo-produto.component.html',
  styleUrls: ['./grupo-produto.component.scss']
})
export class GrupoProdutoComponent implements OnInit {
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  grupoProduto = {} as GrupoProdutoModel;
  grupoProdutos: GrupoProdutoModel[];

  public page : ResponsePageable;
  public pageAtual = 0;
  public submit = false;
  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;

  public arrayString: string;
  public creatorGrupoProduto = false;
  public editorGrupoProduto = false;
  public listGrupoProduto = false;
  public deleteGrupoProduto = false;
  public superUser = false;

  @ViewChild('cardEdit') targetEl: ElementRef;

  constructor(private grupoProdutoService: GrupoProdutoService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService) { }

  ngOnInit() {
    this.getPageGrupoProdutos(0, 10);
    this.getAuthority();
  }

  changePage(event){
    this.getPageGrupoProdutos(event.page, event.size);
    this.pageAtual = event.page;
  }

  onSubmit(){
    this.submit = true;
  }

  postSubmit() {
    this.submit = false;
    this.grupoProduto.id = undefined;
    this.grupoProduto.descricao = null;
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  getPageGrupoProdutos(page, size){
    this.grupoProdutoService.getPageGrupoProduto(page, size).subscribe(data => {
      this.page = data;
      this.grupoProdutos = this.page.content;
    });
  }

  saveOrEdit() {
    if (this.grupoProduto.id !== undefined) {
      this.editarGrupoProduto();
    } else {
      this.adicionarGrupo();
    }
  }

  editarGrupoProduto() {
    this.grupoProdutoService.putGrupoProduto(this.grupoProduto).subscribe(() => {
      this.grupoProduto = new GrupoProdutoModel();
      this.openSnackBarSuccess('Grupo de Produto atualizado com sucesso !');
      this.getPageGrupoProdutos(this.pageAtual, 10);
      this.postSubmit();
    }, err => {
      this.openSnackBarError('Erro ao tentar atualizar o Grupo de Produto');
      console.error(err);
    });
  }

  adicionarGrupo() {
    this.grupoProdutoService.postGrupoProduto(this.grupoProduto).subscribe( data => {
        this.grupoProduto = new GrupoProdutoModel();
        this.getPageGrupoProdutos(0, 10);
        this.openSnackBarSuccess('Grupo de Produto adicionado com sucesso !');
        this.postSubmit();
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao tentar salvar o Grupo de Produto !');
    });
  }

  editGrupoProduto(grupoProduto: GrupoProdutoModel) {
    this.grupoProduto = { ...grupoProduto }
  }

  confirmeExclusao(id: number){
    var confirme = confirm("Deseja excluir este grupo de produto ?")
    if(confirme == true){
      this.apagarGrupoProduto(id);
    } else {
      console.log("Cancelou exclusão");
    }
  }

  apagarGrupoProduto(id: number){
    this.grupoProdutoService.deleteGrupoProduto(id).subscribe(() => {
      this.grupoProduto = new GrupoProdutoModel();
      this.openSnackBarSuccess('Grupo de Produto excluído com sucesso !');
      this.getPageGrupoProdutos(0, 10);
    }, error => {
      if(error.status == 500) {
        this.openSnackBarError('Erro ao excluir! Este grupo está sendo usado por um produto.');
      } else {
        this.openSnackBarError('Erro ao tentar excluir o Grupo de Produto !');
      }
    });
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_PRODUTO')) {
      this.creatorGrupoProduto = true;
    }
    if (this.arrayString.includes('EDIT_PRODUTO')) {
      this.editorGrupoProduto = true;
    }
    if (this.arrayString.includes('LIST_PRODUTO')) {
      this.listGrupoProduto = true;
    }
    if (this.arrayString.includes('DELETE_PRODUTO')) {
      this.deleteGrupoProduto = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

 // SnackBares
 openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}

}



// WEBPACK FOOTER //
// /app/src/app/components/produto-components/grupo-produto/grupo-produto.component.ts